import axios from 'axios'

const getProgramStatusList = async (organizationId, programId) => {
    try {
        const response = await axios.get(
          `/organization/${organizationId}/program/${programId}/status`
        );
        return response.data;
    } catch (e) {
        throw new Error(`API error:${e?.message}`);
    }
};
export default getProgramStatusList